import { render, staticRenderFns } from "./BundledCategoryFooterMenu.vue?vue&type=template&id=8ccfaca8&"
import script from "./BundledCategoryFooterMenu.vue?vue&type=script&lang=js&"
export * from "./BundledCategoryFooterMenu.vue?vue&type=script&lang=js&"
import style0 from "./BundledCategoryFooterMenu.vue?vue&type=style&index=0&id=8ccfaca8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports